module.exports = __webpack_public_path__ + "img/gift4-01-c09-t1.3fff7107.png";